import apiClient from './client';
import type { ApiResponse, TotpSetupResponse, TotpConfirmResponse, TotpDisableResponse } from '../types';

export async function setupTotp(): Promise<TotpSetupResponse> {
  const response = await apiClient.post<ApiResponse<TotpSetupResponse>>('/api/v1/auth/totp/setup');
  if (!response.data.success || !response.data.data) {
    throw new Error(response.data.message || 'Failed to start TOTP setup');
  }
  return response.data.data;
}

export async function confirmTotp(code: string): Promise<TotpConfirmResponse> {
  const response = await apiClient.post<ApiResponse<TotpConfirmResponse>>('/api/v1/auth/totp/confirm', { code });
  if (!response.data.success || !response.data.data) {
    throw new Error(response.data.message || 'Failed to confirm TOTP');
  }
  return response.data.data;
}

export async function disableTotp(code: string): Promise<TotpDisableResponse> {
  const response = await apiClient.post<ApiResponse<TotpDisableResponse>>('/api/v1/auth/totp/disable', { code });
  if (!response.data.success || !response.data.data) {
    throw new Error(response.data.message || 'Failed to disable TOTP');
  }
  return response.data.data;
}
